import { render } from "./IconButton.vue?vue&type=template&id=32a79a20"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"
script.render = render

export default script